// XPEN-3776: the refusals of the line decision route (/approvals/line-item/…/approve|deny)
// that the user can act on, with their own message instead of the generic saving error.
const LINE_DECISION_ERRORS = {
  restricted_access: 'approval_modal.restricted_access',
  denial_reason_required: 'approval_modal.deny_reason_required',
};

export const lineDecisionErrorKey = (responseData) =>
  LINE_DECISION_ERRORS[responseData?.msg || responseData?.error] || null;
